import React from 'react';
import { ParentPaper } from '../../atoms/parent-paper';
import { SpotSummary } from '../../organisms/spot/spot-summary/spot-summary';
import { useSpotSummary } from '../../molecules/use-spot-summary';

export const SpotOverview = () => {
  const { row, summary, summaryError, summaryLoading, priceView } =
    useSpotSummary();

  return (
    <>
      <ParentPaper sx={{ pt: 1 }}>
        {row}

        <SpotSummary
          summary={summary}
          summaryError={summaryError}
          summaryLoading={summaryLoading}
          priceView={priceView}
        />
      </ParentPaper>
    </>
  );
};
